// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3sEa1","label":"Completed_label__3723Q"};